import { render, staticRenderFns } from "./index.vue?vue&type=template&id=81b88e16&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=81b88e16&scoped=true&lang=css&"
import style1 from "./index.scss?vue&type=style&index=1&id=81b88e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b88e16",
  null
  
)

export default component.exports